'use client'

import { setCookie, deleteCookie } from 'cookies-next'
import { useCallback, useEffect } from 'react'

import {
  isNilOrEmptyString,
  useSession,
  onIdTokenChanged,
  firebaseSignOut,
  FirebaseUser,
} from '@/shared/lib'
import { FIREBASE_COOKIE } from '@/shared/lib/server'

type Props = {
  initialUser: FirebaseUser | null
}

export const FirebaseProvider = ({ initialUser }: Props) => {
  const session = useSession()

  const firebaseToken = session?.data?.firebaseToken

  const initializeFirebase = useCallback(async () => {
    if (isNilOrEmptyString(firebaseToken)) {
      await firebaseSignOut()

      return
    }
  }, [firebaseToken])

  useEffect(() => {
    void initializeFirebase()
  }, [initializeFirebase])

  useEffect(() => {
    return onIdTokenChanged(async user => {
      if (user) {
        const idToken = await user.getIdToken()
        await setCookie(FIREBASE_COOKIE, idToken)
      } else {
        await deleteCookie(FIREBASE_COOKIE)
      }

      if (initialUser?.uid === user?.uid) {
        return
      }

      window.location.reload()
    })
  }, [initialUser])

  return null
}
